<template>
  <EditableTextArea
    :key="text"
    :defaultValue="text"
    @update:modelValue="$emit('update:modelValue', $event)"
    :rows="rows"
    :maxLength="maxLength"
    :variant="variant"
    :placeholder="placeholder"
    :readonly="readonly || !showingOriginal"
    :autoResize="autoResize"
    :startWithEditMode="startWithEditMode"
    :submitMode="submitMode"
    :controls="controls"
    :class="props.class"
    @update="$emit('update', $event)"
  />
  <div v-if="!showingOriginal">
    <span
      class="text-utility-brand-500 hover:text-utility-brand-700 text-style-sm font-medium transition-colors cursor-pointer"
      @click="$emit('update:showOriginal', true)"
    >
      {{ $t("admin.view_task.show_original") }}
    </span>
  </div>
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { isEmpty, isEqual } from "lodash";
import { EditableTextArea } from "@/SharedComponents/Inputs";

defineEmits(["update", "update:modelValue", "update:showOriginal"]);

const props = defineProps({
  original: { type: String, default: null },
  translation: { type: String, required: false },
  showOriginal: { type: Boolean, required: false },
  rows: { type: [Number, String], required: false },
  maxLength: { type: [String, Number], required: false },
  variant: { type: String, required: false },
  placeholder: { type: String, required: false },
  readonly: { type: Boolean, default: false },
  autoResize: { type: Boolean, default: true },
  startWithEditMode: { type: Boolean, default: false },
  submitMode: { type: String, required: false },
  controls: { type: Boolean, required: false },
  class: { type: null, required: false },
});

const value = ref(props.original);
watchEffect(() => {
  value.value = props.original;
});

const text = computed(() => {
  return props.translation
    ? props.showOriginal
      ? value.value
      : props.translation
    : value.value;
});

const showingOriginal = computed(
  () => isEmpty(text.value) || isEqual(text.value, props.original)
);
</script>
